/* eslint-disable */
import React, { useState, useRef, useEffect } from "react"
import Styles from "./TechnologySection.module.scss"
import { css } from "@jsUtils"

const TechnologySection = props => {
  const sectionRef = useRef()
  const [mounted, setMounted] = useState(false)
  const { children, type, asset, register, start, loop, out } = props

  const animate = () => {
    //requestAnimationFrame(animate)
    // if( sectionRef.current.scrollTop  )
    // console.log(sectionRef.current.offsetTop - window.scrollY )
  }
  useEffect(() => {
    if (!mounted) {
      setMounted(true)
    } else {
      // animate();
      register(sectionRef, type, asset, start, loop, out)
    }
  }, [mounted])
  return (
    <div
      className={css(Styles.component, props.className && Styles[props.className])}
      ref={sectionRef}
    >
      {children && children}
      {!children && <div>SECTION</div>}
    </div>
  )
}

export default TechnologySection
